import { render, staticRenderFns } from "./listAPD.vue?vue&type=template&id=7132e06b&scoped=true&"
import script from "./listAPD.vue?vue&type=script&lang=js&"
export * from "./listAPD.vue?vue&type=script&lang=js&"
import style0 from "./listAPD.vue?vue&type=style&index=0&id=7132e06b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7132e06b",
  null
  
)

export default component.exports